var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscendingSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.201 8.89567C7.61128 8.89567 7.8277 9.38162 7.55324 9.68658L4.35226 13.2432C4.16401 13.4524 3.83603 13.4524 3.64778 13.2432L0.4468 9.68658C0.172336 9.38162 0.388759 8.89567 0.799042 8.89567H7.201Z",
    fill: "#8993A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799042 5.10452C0.388759 5.10452 0.172335 4.61857 0.4468 4.31361L3.64778 0.756973C3.83603 0.547806 4.16401 0.547806 4.35226 0.756973L7.55324 4.31361C7.8277 4.61857 7.61128 5.10453 7.201 5.10452L0.799042 5.10452Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingSort);
export default __webpack_public_path__ + "static/media/ascending-sort.a60c7e0035323921d5b123862e536cfa.svg";
export { ForwardRef as ReactComponent };